import { SavedSearch } from '@sbt-web/network/types';
import { getCategory } from '@sbt-web/tracking';
import { SearchState } from '@/reducers/search';
import { PublicUser } from '@/shared/models';
import { getDataLayer, getOrCreatePulse } from '@/tools/tracking/utils';

export interface SavedSearchesEvents {
  onLoginInPlace(search: SearchState, user: PublicUser): void;
  onBeforeSave(search: SearchState): void;
  onSave(search: SearchState, payload: SavedSearch): void;
}
export class DefaultTrackingEvents implements SavedSearchesEvents {
  onLoginInPlace() {
    getOrCreatePulse()?.queueEvent({
      type: 'Login',
      object: {
        id: 'login-inplace',
        type: 'Confirmation',
        items: [{ searchId: '0000000000000000' }],
      },
      target: {
        id: 'login-inplace',
        type: 'Confirmation',
      },
      origin: {
        description: 'view-form-save-listing',
      },
    });
  }
  onBeforeSave() {
    const rawData = getDataLayer();
    getOrCreatePulse()?.queueEvent({
      type: 'Engagement',
      object: {
        id: 'save-search-button',
        type: 'UIElement',
        elementType: 'button',
      },
      target: {
        id: '0000000000000000',
        type: 'Listing',
      },
      origin: {
        type: 'Listing',
        id: `sdrn:subito:listing:${window.document.URL}`,
        name: rawData.page.name,
      },
    });
  }
  onSave(search: SearchState, payload: SavedSearch) {
    const rawData = getDataLayer();
    getOrCreatePulse()?.queueEvent({
      type: 'Save',
      object: {
        type: 'Listing',
        name: rawData.page.name,
        id: payload.searchId,
        savedSearchId: payload.searchId,
        category: getCategory(rawData.search.category.parent.id),
      },
      search: {
        '@id': search.id ?? '0000000000000000',
        '@type': 'SearchMetadata',
      },
      origin: {
        type: 'Listing',
        id: `sdrn:subito:listing:${window.document.URL}`,
        name: rawData.page.name,
      },
      page: {
        pageType: 'listing',
      },
    });
  }
}
